import React, { useState} from 'react';
import { motion } from 'framer-motion';
import './footer.css';

import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../FirebaseComp/firebase'; 

import { 
  FaEnvelope, 
  FaFacebook, 
  FaLinkedin, 
  FaTwitter, 
  FaInstagram, 
  FaYoutube,
  FaGithub,
  FaDiscord
} from 'react-icons/fa';



// Animation variants for the container (staggered children)
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      delay: 0.3,
      staggerChildren: 0.1,
      when: "beforeChildren",
    }
  }
};

// Animation variants for each individual child element
const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      damping: 12,
      stiffness: 100
    }
  }
};

// A separate variant for the top border for a different animation
const borderVariants = {
  hidden: { scaleX: 0, opacity: 0 },
  visible: {
    scaleX: 1,
    opacity: 1,
    transition: {
      delay: 0.2,
      duration: 0.8,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};

function Footer() {
  const currentYear = new Date().getFullYear();

//news letter subscription
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');




  // Footer data
  // const services = [
  //   { name: 'Custom Software Development', url: '/services' },
  //   { name: 'Cloud Solutions', url: '/services' },
  //   { name: 'AI & Machine Learning', url: '/services' },
  //   { name: 'Cybersecurity', url: '/services' },
  //   { name: 'IT Consulting', url: '/services' },
  // ];

 const services = [
    { name: 'Home', url: '/' },
    { name: 'About Us', url: '/aboutus' },
    { name: 'Contact Us', url: '/contactus' },
    { name: 'Services', url: '/services' },
    { name: 'Projects', url: '/projects' },
  ];




  const companyLinks = [
    { name: 'About Us', url: '/aboutus' },
    // { name: 'Our Team', url: '/team' },
    // { name: 'Careers', url: '/careers' },
    { name: 'Blog', url: '/blog' },
  ];

  // const supportLinks = [
  //   { name: 'Contact Us', url: '/contactus' },
  //   { name: 'Help Center', url: '/support' },
  //   { name: 'Documentation', url: '/docs' },
  //   { name: 'Status', url: '/status' },
  // ];

const socialLinks = [
  { 
    name: 'Email', 
    url: 'mailto:info@glaxmore.com', 
    icon: <FaEnvelope /> 
  },
  { 
    name: 'Facebook', 
    url: 'https://web.facebook.com/profile.php?id=61580185183438', 
    icon: <FaFacebook /> 
  },
  //   { 
  //   name: 'Instagram', 
  //   url: 'https://instagram.com/learnex', 
  //   icon: <FaInstagram /> 
  // },
  // { 
  //   name: 'LinkedIn', 
  //   url: 'https://linkedin.com/company/learnex', 
  //   icon: <FaLinkedin /> 
  // },


];








  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Basic email validation
    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setError('Please enter a valid email address');
      return;
    }
    
    setIsSubmitting(true);
    setError('');
    
    try {
      // Save to Firebase
      await addDoc(collection(db, "subscribe"), {
        email: email,
        subscribedAt: serverTimestamp(),
      });
      
      // Show success message
      setIsSubmitted(true);
      setEmail('');
      
      // Reset after 3 seconds
      setTimeout(() => {
        setIsSubmitted(false);
      }, 3000);
    } catch (err) {
      console.error("Error saving email:", err);
      setError('Failed to subscribe. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };











  return (
    <motion.footer 
      className="footer"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
      variants={containerVariants}
    >
      {/* Animated top border */}
      <motion.div className="footer-border" variants={borderVariants} />

      <div className="footer-content">
        {/* Brand Section */}
        <motion.div className="footer-brand-section" variants={itemVariants}>
          <div className="footer-logo">
            <img src="/logo192.png" alt="LEARNEX Logo" className="logo-img" />
            <div className="logo-text">
              <span className="brand-name">GLAXMORE</span>
              <span className="brand-tagline">Your Partner in Smarter IT Innovation</span>
            </div>
          </div>
          
          <motion.blockquote 
            className="vision-quote"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.5, duration: 0.8 }}
          >
            "To inspire innovation and lead the way in creating smarter IT solutions for a better tomorrow."
          </motion.blockquote>
          
            <div className="footer-social">
              {socialLinks.map((link, index) => (
                <motion.a
                  key={index}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  whileHover={{ scale: 1.1, y: -2 }}
                  whileTap={{ scale: 0.95 }}
                  aria-label={link.name}
                >
                  {link.icon}
                </motion.a>
            ))}
          </div>
        </motion.div>

        {/* Links Sections */}
        <div className="footer-links-container">
          {/* Services */}
          <motion.div className="footer-section" variants={itemVariants}>
            <h4 className="footer-subheading">Services</h4>
            <ul className="footer-link-list">
              {services.map((link, index) => (
                <li key={index}>
                  <motion.a 
                    href={link.url} 
                    className="footer-link"
                    whileHover={{ x: 5, color: 'var(--primary)' }}
                    transition={{ type: "spring", stiffness: 400, damping: 17 }}
                  >
                    {link.name}
                  </motion.a>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Company */}
          <motion.div className="footer-section" variants={itemVariants}>
            <h4 className="footer-subheading">Company</h4>
            <ul className="footer-link-list">
              {companyLinks.map((link, index) => (
                <li key={index}>
                  <motion.a 
                    href={link.url} 
                    className="footer-link"
                    whileHover={{ x: 5, color: 'var(--primary)' }}
                    transition={{ type: "spring", stiffness: 400, damping: 17 }}
                  >
                    {link.name}
                  </motion.a>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Support */}
          {/* <motion.div className="footer-section" variants={itemVariants}>
            <h4 className="footer-subheading">Support</h4>
            <ul className="footer-link-list">
              {supportLinks.map((link, index) => (
                <li key={index}>
                  <motion.a 
                    href={link.url} 
                    className="footer-link"
                    whileHover={{ x: 5, color: 'var(--primary)' }}
                    transition={{ type: "spring", stiffness: 400, damping: 17 }}
                  >
                    {link.name}
                  </motion.a>
                </li>
              ))}
            </ul>
          </motion.div> */}

          {/* Contact Info */}
          <motion.div className="footer-section" variants={itemVariants}>
            <h4 className="footer-subheading">Contact Info</h4>
            <div className="contact-info">
              <p>33, Sri Dharmarama Road</p>
              <p>Ratmalana, Sri Lanka</p>
<p className="contact-phone">
  <a href="tel:+94701111735" style={{ textDecoration: "none", color: "inherit" }}>
    +94 70 1111 735
  </a>
</p>
<p className="contact-phone">
  <a href="tel:+94765610017" style={{ textDecoration: "none", color: "inherit" }}>
    +94 76 5610 017
  </a>
</p>
<p className="contact-email">
  <a href="mailto:info@glaxmore.com" style={{ textDecoration: "none", color: "inherit" }}>
    info@glaxmore.com
  </a>
</p>
<p className="contact-email">
  <a href="mailto:support@glaxmore.com" style={{ textDecoration: "none", color: "inherit" }}>
    support@glaxmore.com
  </a>
</p>

            </div>
          </motion.div>
        </div>
      </div>

      {/* Newsletter Subscription */}
    <motion.div className="footer-newsletter" variants={itemVariants}>
      <h4>Stay Updated with GLAXMORE</h4>
      
      {isSubmitted ? (
        <motion.div 
          className="subscription-success"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className="success-icon">✓</div>
          <p>Thank you for subscribing!</p>
        </motion.div>
      ) : (
        <form onSubmit={handleSubmit} className="newsletter-form">
          <div className="newsletter-input-container">
            <input 
              type="email" 
              placeholder="Enter your email address" 
              className="newsletter-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isSubmitting}
            />
            <motion.button 
              className="newsletter-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              disabled={isSubmitting}
              type="submit"
            >
              {isSubmitting ? 'Submitting...' : 'Subscribe'}
            </motion.button>
          </div>
          {error && <p className="newsletter-error">{error}</p>}
        </form>
      )}
    </motion.div>
  

      {/* Bottom Copyright Bar */}
      <motion.div className="footer-copyright" variants={itemVariants}>
        <p>© {currentYear} GLAXMORE Technologies. All rights reserved.</p>
        <div className="legal-links">
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms-of-services">Terms of Service</a>
     
        </div>
      </motion.div>
    </motion.footer>
  );
}

export default Footer;